import * as z from "zod";

export const getIndigo8Integration = {
  name: "getIndigo8Integration" as const,
  input: z.object({}),
  output: z.object({
    integration: z
      .object({
        baseUrl: z.string(),
        shopifyWebsiteUrl: z.string(),
        shopifyShopName: z.string(),
        apiKeyPreview: z.string(),
        createReturnsEnabled: z.boolean(),
        processReturnsEnabled: z.boolean(),
      })
      .nullable(),
  }),
};
